import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { SITENAMEALIAS, ASSETS } from "../utils/init";
import { useHistory } from "react-router-dom";
import { render } from "react-dom";
import {
  GetAllEmailBills,
  SendEmailBill,
  FetchUsdBtcLedgerAmount,
} from "../utils/service";
import { Modal } from "react-bootstrap";
import Moment from "react-moment";
import PageHeader from "../components/PageHeader";
import {
  showToast,
  showHttpError,
  formatAmount,
  currentPageAccess,
  handleCurrencyDetiails,
  getCurrencyWiseTxnCharge,
} from "../utils/library";

const es = {
  pageWrapper: { padding: "36px 24px 60px" },
  headerRow: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    marginBottom: "28px", flexWrap: "wrap", gap: "16px",
  },
  pageTitle: { fontSize: "24px", fontWeight: "700", color: "var(--text-color)", margin: 0 },
  pageSubtitle: { fontSize: "13px", opacity: 0.5, margin: "4px 0 0" },
  btnPrimary: {
    display: "inline-flex", alignItems: "center", gap: "8px",
    padding: "10px 24px", background: "var(--btn-color)", color: "#fff",
    border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600",
    cursor: "pointer", transition: "all 0.2s ease", whiteSpace: "nowrap",
  },
  btnDisabled: { opacity: 0.4, cursor: "not-allowed" },
  card: {
    background: "var(--body-color-less)", borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)", overflow: "hidden",
  },
  tableWrapper: { overflowX: "auto", overflowY: "hidden", WebkitOverflowScrolling: "touch" },
  table: { width: "100%", borderCollapse: "collapse" },
  th: {
    padding: "14px 16px", fontSize: "11px", fontWeight: "700",
    textTransform: "uppercase", letterSpacing: "0.5px",
    color: "var(--text-color)", opacity: 0.5,
    borderBottom: "1px solid var(--body-color-less2)",
    textAlign: "left", whiteSpace: "nowrap", background: "var(--body-color-less)",
  },
  td: {
    padding: "14px 16px", fontSize: "13px",
    borderBottom: "1px solid var(--body-color-less2)",
    verticalAlign: "middle", whiteSpace: "nowrap",
  },
  statusBadge: (color) => ({
    display: "inline-flex", alignItems: "center", gap: "5px",
    padding: "4px 12px", borderRadius: "20px", fontSize: "11px", fontWeight: "600",
    background:
      color === "green" ? "rgba(16,185,129,0.1)" :
        color === "blue" ? "rgba(59,130,246,0.1)" :
          color === "amber" ? "rgba(245,158,11,0.1)" :
            color === "red" ? "rgba(239,68,68,0.1)" : "rgba(107,114,128,0.1)",
    color:
      color === "green" ? "#10b981" :
        color === "blue" ? "#3b82f6" :
          color === "amber" ? "#f59e0b" :
            color === "red" ? "#ef4444" : "#6b7280",
  }),
  statusDot: (color) => ({
    width: "6px", height: "6px", borderRadius: "50%",
    background:
      color === "green" ? "#10b981" :
        color === "blue" ? "#3b82f6" :
          color === "amber" ? "#f59e0b" :
            color === "red" ? "#ef4444" : "#6b7280",
  }),
  actionBtnEdit: {
    display: "inline-flex", alignItems: "center", gap: "5px",
    padding: "6px 14px", background: "transparent",
    color: "var(--btn-color)", border: "1px solid var(--btn-color)",
    borderRadius: "8px", fontSize: "12px", fontWeight: "600",
    cursor: "pointer", transition: "all 0.2s ease", marginRight: "8px",
  },
  actionBtnSend: {
    display: "inline-flex", alignItems: "center", gap: "5px",
    padding: "6px 14px", background: "#10b981", color: "#fff",
    border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "600",
    cursor: "pointer", transition: "all 0.2s ease",
  },
  actionBtnDisabled: { opacity: 0.4, cursor: "not-allowed" },
  emptyState: { padding: "60px 20px", textAlign: "center" },
  emptyIcon: { fontSize: "48px", opacity: 0.15, marginBottom: "16px" },
  emptyText: { fontSize: "14px", opacity: 0.4, fontWeight: "500" },
  billChip: {
    fontFamily: "monospace", fontSize: "12px", padding: "3px 8px",
    background: "var(--body-color-less2)", borderRadius: "6px",
  },
  // Modal styles
  modalHeader: {
    display: "flex", alignItems: "center", justifyContent: "space-between",
    padding: "20px 24px", borderBottom: "1px solid var(--body-color-less2)",
  },
  modalTitle: { fontSize: "18px", fontWeight: "700", margin: 0 },
  modalClose: {
    width: "32px", height: "32px", display: "flex",
    alignItems: "center", justifyContent: "center",
    borderRadius: "8px", border: "none", background: "var(--body-color-less2)",
    cursor: "pointer", fontSize: "18px", color: "var(--text-color)", opacity: 0.6,
  },
  modalBody: { padding: "24px" },
  modalSectionHeader: {
    display: "flex", alignItems: "center", gap: "10px",
    padding: "12px 16px",
    background: "linear-gradient(135deg, color-mix(in srgb, var(--btn-color), transparent 88%), color-mix(in srgb, var(--btn-color), transparent 94%))",
    borderRadius: "10px", marginBottom: "20px",
  },
  modalSectionTitle: { fontSize: "14px", fontWeight: "700", margin: 0, color: "var(--btn-color)" },
  modalFormRow: { display: "flex", gap: "20px", marginBottom: "20px" },
  modalFormGroup: { flex: 1, display: "flex", flexDirection: "column" },
  modalLabel: {
    fontSize: "12px", fontWeight: "600", textTransform: "uppercase",
    letterSpacing: "0.3px", opacity: 0.7, marginBottom: "6px",
  },
  modalInput: {
    width: "100%", padding: "10px 14px", fontSize: "14px", borderRadius: "10px",
    border: "1px solid var(--body-color-less2)", background: "var(--body-color)",
    color: "var(--text-color)", outline: "none", boxSizing: "border-box",
  },
  modalSelect: {
    width: "100%", padding: "10px 14px", fontSize: "14px", borderRadius: "10px",
    border: "1px solid var(--body-color-less2)", background: "var(--body-color)",
    color: "var(--text-color)", outline: "none", boxSizing: "border-box", appearance: "auto",
  },
  modalFooter: {
    display: "flex", alignItems: "center", justifyContent: "flex-end",
    gap: "10px", padding: "16px 24px", borderTop: "1px solid var(--body-color-less2)",
  },
  btnDanger: {
    padding: "10px 24px", background: "rgba(239,68,68,0.1)", color: "#ef4444",
    border: "1px solid rgba(239,68,68,0.2)", borderRadius: "10px",
    fontSize: "13px", fontWeight: "600", cursor: "pointer",
  },
};

const getStatusInfo = (status) => {
  if (status == "27") return { label: "Draft", color: "amber" };
  if (status == "28") return { label: "Sent", color: "blue" };
  if (status == "29") return { label: "Paid", color: "green" };
  return { label: "Overpaid", color: "red" };
};

class EmailBilling extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      noOfItemsPerPage: 50,
      pageNo: 1,
      totalCount: 0,
      emailBillList: [],
      assets: [],
      permission: "",
      // ── Processing Fee ──
      processingFeeHandling: "customer",
      // ── txn charge for modal's selected currency ──
      txnCharge: null,
    };
  }

  // ── Fetch txn charge for the given asset code and store in state ──
  fetchTxnCharge = async (assetCode) => {
    const charge = await getCurrencyWiseTxnCharge(assetCode);
    this.setState({ txnCharge: charge });
  };

  renderEmailBilling = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      no_of_items_in_a_page: this.state.noOfItemsPerPage,
      page_no: this.state.pageNo,
    };
    this.setState({ showLoader: true });
    GetAllEmailBills(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let errorObj = response[response.length - 1];
          if (errorObj.error != "0") {
            showToast("error", errorObj.error_msg);
          } else {
            let data = [];
            for (let i = 0; i < response.length - 1; i++) {
              data.push(response[i]);
            }
            this.setState({ totalCount: errorObj.total_count, emailBillList: data });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleSendEmailBill = (billId) => {
    if (this.state.permission == "WRITE") {
      let payload = {
        bill_id: billId,
        merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      };
      this.setState({ showLoader: true });
      SendEmailBill(payload)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            let response = res.data[0];
            if (response.error != "0") {
              showToast("error", response.error_msg);
            } else {
              showToast("success", "Bill send successfully");
              this.renderEmailBilling();
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            console.log(err);
            showHttpError(err);
          }.bind(this)
        );
    } else {
      showToast("error", "You need write access to perform this operation");
    }
  };

  // ── handleSignup wires is_processing_fee_applied into the new-bill payload ──
  handleSignup = (event) => {
    event.preventDefault();
    // Existing new-bill creation logic should include:
    // is_processing_fee_applied: this.state.processingFeeHandling === "customer" ? 1 : 0
  };

  // ── Handle currency change in modal ──
  handleModalCurrencyChange = (e) => {
    const selectedOption = this.state.assets.find(a => String(a.assetId) === String(e.target.value));
    if (selectedOption) {
      this.fetchTxnCharge(selectedOption.assetCode);
    }
  };

  handleRenderAssets = () => {
    let payload = { merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id") };
    this.setState({ showLoader: true });
    FetchUsdBtcLedgerAmount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response != undefined && response != null) {
              let coinBalance = response.coin_balance;
              let arr = [];
              if (coinBalance != undefined) {
                for (let i = 0; i < coinBalance.length; i++) {
                  if (coinBalance[i].currency_code != "USD") {
                    let obj = {
                      assetName: coinBalance[i].currency_name,
                      coinBalance: coinBalance[i].balance,
                      assetCode: coinBalance[i].currency_code,
                      assetId: coinBalance[i].currency_id,
                      assetImage: coinBalance[i].logo,
                      network: coinBalance[i].network,
                      isBrokerCurrency: coinBalance[i].is_broker_currency,
                    };
                    arr.push(obj);
                  }
                }
              }
              const currencyOrder = ['USDC', 'USDT', 'XRP', 'DOGE', 'HCX', 'ETH', 'BTC', 'LTC', 'BCH'];
              arr.sort((a, b) => {
                const idxA = currencyOrder.indexOf(a.assetCode);
                const idxB = currencyOrder.indexOf(b.assetCode);
                return (idxA === -1 ? 999 : idxA) - (idxB === -1 ? 999 : idxB);
              });
              this.setState({ assets: arr }, () => {
                localStorage.setItem(SITENAMEALIAS + "_assets", JSON.stringify(this.state.assets));
                // Fetch txn charge for the default (first) asset
                if (arr.length > 0) {
                  this.fetchTxnCharge(arr[0].assetCode);
                }
              });
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  componentDidMount() {
    this.handleRenderAssets();
    this.setState({ permission: currentPageAccess() });
    this.renderEmailBilling();
  }

  render() {
    const canWrite = this.state.permission == "WRITE";
    const { processingFeeHandling, txnCharge } = this.state;

    const feeOptionStyle = (val) => ({
      flex: 1,
      display: "flex",
      alignItems: "flex-start",
      gap: "12px",
      padding: "14px 16px",
      borderRadius: "12px",
      border: processingFeeHandling === val
        ? "1.5px solid var(--btn-color)"
        : "1.5px solid var(--body-color-less2)",
      background: processingFeeHandling === val
        ? "color-mix(in srgb, var(--btn-color), transparent 93%)"
        : "var(--body-color)",
      cursor: "pointer",
      userSelect: "none",
      transition: "all 0.15s ease",
    });

    const radioDotStyle = (val) => ({
      width: "16px",
      height: "16px",
      borderRadius: "50%",
      border: processingFeeHandling === val
        ? "5px solid var(--btn-color)"
        : "2px solid color-mix(in srgb, var(--text-color), transparent 55%)",
      background: "var(--body-color)",
      flexShrink: 0,
      marginTop: "2px",
      transition: "all 0.15s ease",
    });

    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={es.pageWrapper}>

              {/* Page Header */}
              <div style={es.headerRow}>
                <PageHeader
                  icon="mdi-receipt"
                  title="Invoices"
                  subtitle={
                    <>
                      Create and manage bills sent via email
                      {this.state.totalCount > 0 && (
                        <span style={{ marginLeft: "8px", fontWeight: "600" }}>
                          {this.state.totalCount} total
                        </span>
                      )}
                    </>
                  }
                />
                <button
                  style={{ ...es.btnPrimary, ...(!canWrite ? es.btnDisabled : {}) }}
                  type="button"
                  onClick={() => {
                    if (canWrite) {
                      this.props.navigate.push("/invoice/new");
                    } else {
                      showToast("error", "You need write access to perform this operation");
                    }
                  }}
                  disabled={!canWrite}
                >
                  <i className="fas fa-plus" style={{ fontSize: "12px" }}></i>
                  Create New Bill
                </button>
              </div>

              {/* Table Card */}
              <div style={es.card}>
                <div style={es.tableWrapper}>
                  <table style={es.table}>
                    <thead>
                      <tr>
                        <th style={es.th}>Name</th>
                        <th style={es.th}>Bill No.</th>
                        <th style={es.th}>Due Date</th>
                        <th style={es.th}>Status</th>
                        <th style={{ ...es.th, textAlign: "right" }}>Amount</th>
                        <th style={{ ...es.th, textAlign: "center" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.emailBillList.map((item) => {
                        const statusInfo = getStatusInfo(item.STATUS);
                        return (
                          <tr key={item.BILL_ID}>
                            <td style={{ ...es.td, fontWeight: "600" }}>{item.NAME}</td>
                            <td style={es.td}>
                              <span style={es.billChip}>{item.BILL_NUMBER}</span>
                            </td>
                            <td style={{ ...es.td, opacity: 0.7 }}>
                              <Moment format="MMM DD, YYYY" date={item.DUE_DATE} />
                            </td>
                            <td style={es.td}>
                              <span style={es.statusBadge(statusInfo.color)}>
                                <span style={es.statusDot(statusInfo.color)}></span>
                                {statusInfo.label}
                              </span>
                            </td>
                            <td style={{ ...es.td, textAlign: "right", fontWeight: "600", fontFamily: "monospace" }}>
                              {formatAmount(item.TOTAL_AMOUNT, 5)}
                            </td>
                            <td style={{ ...es.td, textAlign: "center" }}>
                              <button
                                style={{ ...es.actionBtnEdit, ...(!canWrite ? es.actionBtnDisabled : {}) }}
                                type="button"
                                onClick={() => {
                                  if (canWrite) {
                                    this.props.navigate.push("/edit-email-bill/" + item.BILL_ID);
                                  } else {
                                    showToast("error", "You need write access to perform this operation");
                                  }
                                }}
                                disabled={!canWrite}
                              >
                                <i className="fas fa-pen" style={{ fontSize: "11px" }}></i>
                                Edit
                              </button>
                              <button
                                style={{ ...es.actionBtnSend, ...(!canWrite ? es.actionBtnDisabled : {}) }}
                                type="button"
                                onClick={() => {
                                  if (canWrite) {
                                    this.handleSendEmailBill(item.BILL_ID);
                                  } else {
                                    showToast("error", "You need write access to perform this operation");
                                  }
                                }}
                                disabled={!canWrite}
                              >
                                <i className="fas fa-paper-plane" style={{ fontSize: "11px" }}></i>
                                Send
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>

                  {/* Empty State */}
                  {this.state.emailBillList.length === 0 && !this.state.showLoader && (
                    <div style={es.emptyState}>
                      <div style={es.emptyIcon}>
                        <i className="fas fa-file-invoice"></i>
                      </div>
                      <p style={es.emptyText}>No bills found</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <Footer />
          </div>

          {/* ── New Bill Modal ── */}
          <Modal
            show={this.state.showAddAddressModal}
            backdrop="static"
            size="lg"
            keyboard={false}
            aria-labelledby="example-modal-sizes-title-lg"
          >
            <div style={es.modalHeader}>
              <h3 style={es.modalTitle}>New Bill</h3>
              <button
                type="button"
                style={es.modalClose}
                onClick={() => this.setState({ showAddAddressModal: false })}
              >
                <i className="fas fa-xmark"></i>
              </button>
            </div>

            <div style={es.modalBody}>
              <form onSubmit={(event) => { this.handleSignup(event); }}>

                {/* Buyer Information Section */}
                <div style={es.modalSectionHeader}>
                  <i className="fas fa-user" style={{ color: "var(--btn-color)", fontSize: "14px" }}></i>
                  <h4 style={es.modalSectionTitle}>Buyer Information</h4>
                </div>
                <div style={es.modalFormRow}>
                  <div style={es.modalFormGroup}>
                    <label style={es.modalLabel}>Email Address</label>
                    <input type="text" style={es.modalInput} ref={this.organizationRef} placeholder="Enter buyer's email address" />
                  </div>
                  <div style={es.modalFormGroup}>
                    <label style={es.modalLabel}>Name</label>
                    <input type="text" style={es.modalInput} ref={this.firstNameRef} placeholder="Buyer's name" />
                  </div>
                </div>

                {/* Bill Details Section */}
                <div style={es.modalSectionHeader}>
                  <i className="fas fa-file-invoice-dollar" style={{ color: "var(--btn-color)", fontSize: "14px" }}></i>
                  <h4 style={es.modalSectionTitle}>Bill Details</h4>
                </div>
                <div style={es.modalFormRow}>
                  <div style={es.modalFormGroup}>
                    <label style={es.modalLabel}>Currency</label>
                    <select
                      style={es.modalSelect}
                      id="currency_dropdown"
                      onChange={this.handleModalCurrencyChange}
                    >
                      {this.state.assets.map((item) => (
                        <option key={item.assetId} value={item.assetId}>
                          {item.assetCode} - {item.assetName}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={es.modalFormGroup}></div>
                </div>
                <div style={es.modalFormRow}>
                  <div style={es.modalFormGroup}>
                    <label style={es.modalLabel}>Due Date</label>
                    <input type="text" style={es.modalInput} ref={this.organizationRef} placeholder="Choose a date" />
                  </div>
                  <div style={es.modalFormGroup}>
                    <label style={es.modalLabel}>Bill Number</label>
                    <input type="text" style={es.modalInput} ref={this.firstNameRef} placeholder="Enter bill number" />
                  </div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "20px" }}>
                  <input
                    type="checkbox"
                    id="recurring_bill"
                    style={{ width: "16px", height: "16px", accentColor: "var(--btn-color)" }}
                  />
                  <label htmlFor="recurring_bill" style={{ fontSize: "13px", margin: 0 }}>
                    This is a recurring bill
                  </label>
                </div>

                {/* ══ Processing Fee Handling Section ══ */}
                <div style={{
                  borderTop: "1px solid var(--body-color-less2)",
                  paddingTop: "20px",
                  marginBottom: "20px",
                }}>
                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    padding: "12px 16px",
                    background: "linear-gradient(135deg, color-mix(in srgb, #14b8a6, transparent 88%), color-mix(in srgb, #14b8a6, transparent 94%))",
                    borderRadius: "10px",
                    marginBottom: "16px",
                  }}>
                    <i className="fa fa-percent" style={{ color: "#14b8a6", fontSize: "15px" }}></i>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <h4 style={{ ...es.modalSectionTitle, color: "#14b8a6", margin: 0 }}>
                        Processing Fee Handling
                      </h4>
                      {txnCharge != null && (
                        <span style={{ fontSize: "11px", fontWeight: "700", color: "#14b8a6", background: "color-mix(in srgb, #14b8a6, transparent 80%)", borderRadius: "6px", padding: "2px 8px" }}>
                          {txnCharge}
                        </span>
                      )}
                    </div>
                  </div>

                  <p style={{ fontSize: "12px", color: "var(--text-color)", opacity: 0.55, margin: "0 0 14px" }}>
                    Choose how transaction fees are applied for this bill.
                  </p>

                  <div style={{ display: "flex", gap: "12px" }}>
                    <div style={feeOptionStyle("customer")} onClick={() => this.setState({ processingFeeHandling: "customer" })}>
                      <div style={radioDotStyle("customer")} />
                      <div>
                        <div style={{ fontSize: "13px", fontWeight: "600", color: "var(--text-color)", marginBottom: "3px" }}>
                          Customer pays the processing fee
                        </div>
                        <div style={{ fontSize: "11px", color: "var(--text-color)", opacity: 0.5 }}>
                          {txnCharge != null ? `${txnCharge} will be added to the checkout total.` : "The fee will be added to the checkout total."}
                        </div>
                      </div>
                    </div>
                    <div style={feeOptionStyle("merchant")} onClick={() => this.setState({ processingFeeHandling: "merchant" })}>
                      <div style={radioDotStyle("merchant")} />
                      <div>
                        <div style={{ fontSize: "13px", fontWeight: "600", color: "var(--text-color)", marginBottom: "3px" }}>
                          Merchant absorbs the processing fee
                        </div>
                        <div style={{ fontSize: "11px", color: "var(--text-color)", opacity: 0.5 }}>
                          {txnCharge != null ? `${txnCharge} will be deducted from your payout.` : "The fee will be deducted from your payout."}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* ══ End Processing Fee Handling Section ══ */}

                {/* Line Items Section */}
                <div style={{ borderTop: "1px solid var(--body-color-less2)", paddingTop: "20px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px" }}>
                    <button type="button" style={es.btnPrimary}>
                      <i className="fas fa-plus" style={{ fontSize: "12px" }}></i>
                      Add New Item
                    </button>
                  </div>
                  <table style={es.table}>
                    <thead>
                      <tr>
                        <th style={es.th}>Item</th>
                        <th style={es.th}>Price</th>
                        <th style={es.th}>Quantity</th>
                        <th style={es.th}>Amount</th>
                        <th style={es.th}>Action</th>
                      </tr>
                    </thead>
                    <tbody id="items_container"></tbody>
                  </table>
                </div>

              </form>
            </div>

            <div style={es.modalFooter}>
              <button
                style={es.btnDanger}
                type="button"
                onClick={() => this.setState({ showAddAddressModal: false })}
              >
                Close
              </button>
            </div>
          </Modal>

          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

function EmailBillingWrapper(props) {
  const history = useHistory();
  return <EmailBilling {...props} navigate={history} />;
}

export default EmailBillingWrapper;